module.exports = __webpack_public_path__ + "img/youmu konpaku_sc2.458e328f.png";